/**
 * Bumping this string invalidates the whole persisted query cache on next launch.
 * Change it whenever a wire shape the app caches changes in a way that would make an
 * old cached payload misrender (a renamed field, a new required key). It is the
 * `buster` handed to persistQueryClient — cheaper and safer than migrating stale data.
 */
export const CACHE_VERSION = '2026-07-16.1';
